/**
 * Pricing Configuration V2
 *
 * New product lineup for the redesigned Ivy Astrology platform.
 * This file sits alongside the existing pricing.config.js - it does NOT replace it.
 * Existing calendar/forecast pricing continues to use pricing.config.js.
 */

export const PRICING_V2 = {
  subscriptions: {
    stars_made_simple_monthly: {
      id: 'stars_made_simple_monthly',
      name: 'Stars Made Simple',
      price: 9.99,
      currency: 'EUR',
      interval: 'month',
      description: 'Daily guidance in plain English',
      features: [
        'Daily personalised cosmic briefing',
        'Weekly transit summary for your chart',
        'Plain English explanations (no jargon)',
        'Monthly highlights and key dates',
        'Email and WhatsApp delivery options',
        'Access to basic transit calendar',
        'Mobile-friendly dashboard',
      ],
    },
    stars_made_simple_annual: {
      id: 'stars_made_simple_annual',
      name: 'Stars Made Simple',
      price: 89.99,
      currency: 'EUR',
      interval: 'year',
      savings: '25%',
      description: 'Daily guidance in plain English - annual plan',
      features: [
        'Everything in the monthly plan',
        '25% savings vs monthly',
        'Priority email support',
        'Early access to new features',
        'Annual transit overview included',
      ],
    },
    claudias_circle_monthly: {
      id: 'claudias_circle_monthly',
      name: "Claudia's Circle VIP",
      price: 49.99,
      currency: 'EUR',
      interval: 'month',
      description: 'The most personal astrology experience available',
      features: [
        'Monthly 1:1 session with Claudia (30 min)',
        'Priority WhatsApp access for quick cosmic questions',
        'Exclusive monthly deep-dive video (VIP only)',
        'Personalised transit alerts for your chart',
        'Early access to all new features and content',
        'Birthday reading included',
        'Full access to all calendar products',
        'Yearly forecast video for your rising sign included',
        'All Stars Made Simple features included',
      ],
    },
    claudias_circle_annual: {
      id: 'claudias_circle_annual',
      name: "Claudia's Circle VIP",
      price: 449.99,
      currency: 'EUR',
      interval: 'year',
      savings: '25%',
      description: 'The most personal astrology experience - annual plan',
      features: [
        'Everything in the monthly VIP plan',
        '25% savings vs monthly',
        'Bonus: Extra 1:1 session on your birthday month',
        'Bonus: Year-ahead personalised forecast',
        'Founding member status',
      ],
    },
  },

  // Only what is delivered after payment belongs here (see PRODUCTS in lambda-functions/ivy-stripe-products/index.js).
  oneTime: {
    compatibility_report: {
      id: 'compatibility_report',
      name: 'Full Compatibility Report',
      // Claudia, 2026-10-28: EUR 39; EUR 29 when the buyer already owns a Birthday Star Portrait (applied server-side).
      price: 39.00,
      portraitOwnerPrice: 29.00,
      currency: 'EUR',
      description: 'Are you meant to be? Twelve sections on the two of you, from what drew you together to the next twelve months',
      features: [
        'Overall compatibility score',
        'Emotional compatibility breakdown',
        'Communication style analysis',
        'Physical and romantic chemistry',
        'Long-term growth potential',
        'Key challenges and how to navigate them',
        'Shareable result card',
      ],
    },
  },
};

/**
 * Get all subscription products
 */
export const getSubscriptions = () => Object.values(PRICING_V2.subscriptions);

/**
 * Get all one-time purchase products
 */
export const getOneTimeProducts = () => Object.values(PRICING_V2.oneTime);

/**
 * Get a specific product by ID across all categories
 */
export const getProductById = (id) => {
  return PRICING_V2.subscriptions[id]
    || PRICING_V2.oneTime[id]
    || null;
};

/**
 * Format price for display
 */
export const formatPrice = (price, currency = 'EUR') => {
  return `${currency} ${price.toFixed(2)}`;
};

export default PRICING_V2;
